export default class SelectSelection {
  constructor(inputs, { multiple, exclusiveValue }) {
    this.inputs = inputs
    this.multiple = multiple
    this.exclusiveValue = exclusiveValue
  }

  availableInputs(query) {
    return this.inputs.filter((input) => {
      if (this.multiple && input.checked) return false

      return !query || this.labelFor(input).toLowerCase().includes(query)
    })
  }

  pick(input) {
    input.checked = true

    if (this.multiple) this.enforceExclusivity(input)
    else this.clearOtherInputs(input)

    this.notifyChange(input)
  }

  unpick(input) {
    input.checked = false
    this.notifyChange(input)
  }

  get checkedInputs() {
    return this.inputs.filter((input) => input.checked)
  }

  get checkedInput() {
    return this.checkedInputs[0]
  }

  get lastCheckedInput() {
    const checkedInputs = this.checkedInputs
    return checkedInputs[checkedInputs.length - 1]
  }

  get pickedLabel() {
    return this.checkedInput ? this.labelFor(this.checkedInput) : ""
  }

  labelFor(input) {
    return input.dataset.selectLabel
  }

  clearOtherInputs(picked) {
    this.inputs.forEach((input) => {
      if (input !== picked) input.checked = false
    })
  }

  enforceExclusivity(picked) {
    if (this.exclusiveValue === undefined) return

    const pickedExclusive = picked.value === this.exclusiveValue
    this.inputs.forEach((input) => {
      if (input === picked) return
      if (pickedExclusive || input.value === this.exclusiveValue) input.checked = false
    })
  }

  notifyChange(input) {
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
